<template>
    <div class="component component__modules">
        <component-modules-item
            v-for="(module, moduleIndex) in modules"
            :key="`component-modules-${moduleIndex}`"
            :index="[...index, moduleIndex]"
            :module="module"
        ></component-modules-item>
    </div>
</template>

<script>
import ComponentModulesItem from '@/components/default/shared/ComponentModulesItem'
export default {
  name: 'component-modules',
  data () {
    return {
      reloadTimeout: ''
    }
  },
  components: { ComponentModulesItem },
  props: {
    modules: {
      type: Array,
      required: true
    },
    index: {
      type: [Array],
      default: () => []
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentmodules";
</style>
